import type { Die } from '../die.type';
import { Modifier } from '../modifier';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';
import type { Player } from '../player.type';

export class Shocked extends Modifier {
  static readonly baseTitle = 'Shocked';
  static readonly baseText = 'Downgrades a die at the start of turn per stack. Stable.';
  static readonly baseIcon = 'dizzy';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Shocked.baseTitle;
  text = Shocked.baseText;
  icon = Shocked.baseIcon;
  tags: Array<ModifierTags> = [...Shocked.baseTags];
  priority = Shocked.basePriority;

  startTurn({
    dice,
    rerollMax,
    activePlayer,
    inactivePlayer,
  }: {
    dice: Array<Die>;
    rerollMax: number;
    activePlayer: Player;
    inactivePlayer: Player;
  }): void | { dice: Array<Die>; rerollMax: number; activePlayer: Player; inactivePlayer: Player } {
    let remainingStacks = this.stacks;
    while (remainingStacks > 0) {
      // Find all dice above level -2
      const eligibleDice = dice.filter((die: Die) => die.level > -2);

      if (eligibleDice.length === 0) {
        break; // No more dice to downgrade
      }

      // Pick a random eligible die
      const die = eligibleDice[Math.floor(Math.random() * eligibleDice.length)];
      die.setLevel(die.level - 1);
      remainingStacks--;
    }

    this.removeStacks(this.stacks);
    return { dice, rerollMax, activePlayer, inactivePlayer };
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Shocked, Shocked);
